import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
import { IoIosArrowBack } from "react-icons/io";
type Props = {
  className?: string;
  hrClassName?: string;
};
export default function ArrowLeft(t0) {
  const $ = _c(10);
  const {
    className,
    hrClassName
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("relative w-full", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== hrClassName) {
    t2 = cn("border-secondary", hrClassName);
    $[2] = hrClassName;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <hr className={t2} />;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="absolute left-0 top-0 -translate-x-1/2 translate-y-[-2px] text-inherit"><IoIosArrowBack className="h-4" /></div>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t3) {
    t5 = <div className={t1}>{t3}{t4}</div>;
    $[7] = t1;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}